import React from "react";

export default function BulletText(props) {
  return (
    <div className="flex gap-[14px] my-[10px]">
      <div>
        <div className="h-[26px] w-[26px] rounded-full bg-lightGray" />
      </div>
      <div>
        <p className="text-[18px] xl:text-[20px] text-left whitespace-pre-line">
          {props.text}
        </p>
        {props.text2 && (
          <p className="text-[18px] xl:text-[20px] text-left whitespace-pre-line">
            {props.text2}
          </p>
        )}
      </div>
    </div>
  );
}
